import {Referral} from "../../referral";
import {Observable} from "rxjs";
import {Controller, useFormContext} from "react-hook-form";
import DatePicker, {ReactDatePickerProps} from "react-datepicker";
import {DatePickerCustomInput, ESBA_DATE_FORMAT} from "../../common";
import {parseISO} from "date-fns";
import React from "react";
import {OfferFormInput} from "./OfferForm";
import {useObservable} from "../../rxsupport";

type StartDateCaregiverMediatedTreatmentInputProps = {
    referral: Referral;
    label: string;
    isRequired?: boolean;
    isSubmitting$: Observable<boolean>;
} & Omit<ReactDatePickerProps, 'onChange'>;

export const StartDatePractMediatedTreatmentInput = ({
                                                         referral,
                                                         label,
                                                         isRequired = true,
                                                         isSubmitting$,
                                                         ...datePickerProps
                                                     }: StartDateCaregiverMediatedTreatmentInputProps) => {
    const {
        control,

        formState: {
            errors,
        },
    } = useFormContext<OfferFormInput>();

    const validationRules = {
        required: {
            message: 'This field is required.',
            value: isRequired,
        }
    };

    const sending = useObservable(isSubmitting$, false);

    return (
        <Controller
            name='startDatePractMediatedTreatment'
            control={control}
            rules={validationRules}
            render={({field: { onChange, onBlur, value: isoValueStr }}) => <DatePicker
                {...datePickerProps}
                disabled={sending}
                onChange={(newValue: Date | null) => onChange(newValue?.toISOString() || null)}
                onBlur={onBlur}
                minDate={new Date()} //TODO: ASK JUAN FOR THE MIN DATE
                dateFormat={ESBA_DATE_FORMAT}
                selected={isoValueStr ? parseISO(isoValueStr) : undefined}
                customInput={
                    <DatePickerCustomInput
                        width='32em'
                        label={label}
                        fieldName='startDatePractMediatedTreatment'
                        error={errors?.startDatePractMediatedTreatment}
                        value={isoValueStr as any}
                    />
                }
            />}
        />
    );

}